module.exports = __webpack_public_path__ + "1ad8471204931476cffa4e528c1215c6.png";